import { createContext, useContext } from 'react'
import LookupStore from './LookupStore'
import LoadingStore from './LoadingStore'
import UserStore from './UserStore'
import NotificationMenuStore from './NotificationMenuStore'
import CommitteeStore from './CommitteeStore'
import QuestionnaireStore from './QuestionnaireStore'

export const storeContext = createContext({
    lookupStore: new LookupStore(),
    loadingStore: new LoadingStore(),
    userStore: new UserStore(),
    notificationMenuStore: new NotificationMenuStore(),
    committeeStore: new CommitteeStore(),
    questionnaireStore: new QuestionnaireStore(),
})
export default () => useContext(storeContext)
